import { ChangeDetectorRef, Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { DialogService } from '@mtgame/ui';
import { isPlatformBrowser } from '@angular/common';
import { ConfigService, League } from '@mtgame/core';
import { HttpClient } from '@angular/common/http';
import { JoinComponent } from '../../../app/join/join.component';
import { LeagueRootService } from '@core/services/league-root.service';

@Component({
  selector: 'mtg-volleyball-league-about',
  templateUrl: './volleyball-league-about.component.html',
  styleUrls: ['../shared/league-about.scss', './volleyball-league-about.component.scss'],
})
export class VolleyballLeagueAboutComponent implements OnInit {
  statistic: any;

  constructor(
    private leagueRootService: LeagueRootService,
    private cdr: ChangeDetectorRef,
    private dialogService: DialogService,
    private httpClient: HttpClient,
    private configService: ConfigService,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {
  }

  async ngOnInit(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      const season = this.leagueRootService.getActiveSeasonModel();
      this.statistic = await this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_season/${season.id}/trvolley_live_statistic/`).toPromise();
      this.cdr.markForCheck();
    }
  }

  openJoinForm(): void {
    this.dialogService.open(JoinComponent, {
      isCloseButtonVisible: true
    });
  }
}
